import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ADD_ITEM_FORM } from '../../constants/formNames';
import { reduxForm, Field, reset } from 'redux-form';
import { map, find, get, compact } from 'lodash';
import SelectField from '../../fields/SelectField/SelectField';
import AddItemFieldSet from '../../fieldSets/AddItemFieldSet/add-item-field-set';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class AddItemForm extends Component {
  constructor (props) {
    super(props);

    this.handleCreateClick = this.handleCreateClick.bind(this);
  }

  handleCreateClick (e) {
    e.preventDefault();

    this.props.dispatch(reset(ADD_ITEM_FORM));
    this.props.toggleModal('createAddOnModal');
  }

  render () {
    const {
      inventory,
      itemId,
      isEditModal,
      editAddOnAction,
      handleItemChange
    } = this.props;

    const selectedItem = find(inventory, { _id: itemId });
    const maxQuantity = get(selectedItem, 'count');
    const unitCostBasis = get(selectedItem, 'unit_cost_basis', '').replace('_', ' ');

    const inventoryOptions = map(inventory, item => {
      const inventoryObj = {
        label: item.label,
        value: item._id,
        quantity: item.count,
        unit_cost: item.unit_cost,
        unit_cost_basis: item.unit_cost_basis
      };

      return !get(item, 'is_concierge', false) ? inventoryObj : null;
    });

    const createAddOnButton = (
      <button
        className="create-add-on-button"
        onClick={this.handleCreateClick}
        data-testing-id="create-add-on-button"
      >
        <span className="ico icon-add margin-md-right" />
        <FormattedMessage
          id='inbox.add_item_form.create'
          defaultMessage='Create add on'
        />
      </button>
    );

    return (
      <form className="add-item-form" data-testing-id="add-item-form">
        {
          itemId || isEditModal ?
            <AddItemFieldSet
              {...this.props}
              inventoryOptions={compact(inventoryOptions)}
              maxQuantity={maxQuantity}
              unitCostBasis={unitCostBasis}
              handleItemChange={handleItemChange}
              editAddOnAction={editAddOnAction}
            />
            :
            <div className="title-section add-item-form-fields flex column margin-xl-bottom" data-testing-id="add-item-form-fields">
              <label>
                <FormattedMessage
                  id='inbox.add_item_form.title'
                  defaultMessage='Title'
                />
              </label>
              <Field
                component={SelectField}
                name="title"
                errorMessage={ this.props.intl.formatMessage({ id: 'inbox.add_item_form.select_item', defaultMessage: 'Please select an item' }) }
                className="form-fields"
                placeholder={ this.props.intl.formatMessage({ id: 'inbox.add_item_form.select', defaultMessage: 'Select' }) }
                options={
                  [...compact(inventoryOptions),
                    {
                      value: null,
                      label: createAddOnButton,
                      isDisabled: true
                    }
                  ]
                }
                maxMenuHeight={260}
                attributes={{ 'data-testing-id': 'title-field' }}
              />
            </div>
        }
      </form>
    );
  }
}

AddItemForm.propTypes = {
  inventory: PropTypes.array,
  isEditModal: PropTypes.bool,
  handleItemChange: PropTypes.func,
  editAddOnAction: PropTypes.func,
  itemId: PropTypes.string,
  intl: intlShape
};

const config = {
  form: ADD_ITEM_FORM
};

export default injectIntl(reduxForm(config)(AddItemForm));
